import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import ResultComponent from "../../../../../api/Admin/ResultComponent";
import { SqcMethodManagementForm } from "../../form";

type ParametersModalProps = {
  onClose(): void;
};

export function ParametersModal({ onClose }: ParametersModalProps) {
  const [loading, setLoading] = useState(false);
  const [resultComponents, setResultComponents] = useState<ResultComponent[]>(
    []
  );

  const [selectedParameter, setSelectedParameter] =
    useState<ResultComponent | null>(null);

  useEffect(() => {
    setLoading(true);

    ResultComponent.getAll()
      .then(setResultComponents)
      .finally(() => setLoading(false));
  }, []);

  const formik = useFormikContext<SqcMethodManagementForm>();

  const handleAdd = () => {
    if (!selectedParameter) return;

    formik.setFieldValue(
      "trackedComponents",
      formik.values.trackedComponents.concat({
        resultComponentName: selectedParameter.name,
        isInformational: false,
      })
    );

    setSelectedParameter(null);
  };

  const handleDelete = (index: number) => {
    formik.setFieldValue(
      "trackedComponents",
      formik.values.trackedComponents.filter((t, i) => i !== index)
    );
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Parameters</DialogTitle>

      <DialogContent dividers>
        <Stack gap="1rem">
          <Stack direction="row" gap="0.5rem" sx={{ alignItems: "center" }}>
            <Autocomplete
              size="small"
              loading={loading}
              options={resultComponents}
              getOptionLabel={(option) => option.name}
              getOptionDisabled={(option) =>
                formik.values.trackedComponents.some(
                  (t) => t.resultComponentName === option.name
                )
              }
              renderOption={(props, option) => (
                <li {...props}>{option.name}</li>
              )}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name
              }
              renderInput={(params) => (
                <TextField {...params} label="Result Component" />
              )}
              value={selectedParameter}
              onChange={(event, value) => setSelectedParameter(value)}
              sx={{ width: "16rem" }}
            />

            <Button
              type="button"
              disabled={!selectedParameter}
              onClick={handleAdd}
            >
              Add
            </Button>
          </Stack>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "4rem" }} />
                  <TableCell>Result Component</TableCell>
                  <TableCell>Informational</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {formik.values.trackedComponents.map((t, index) => (
                  <TableRow key={t.resultComponentName}>
                    <TableCell>
                      <IconButton onClick={() => handleDelete(index)}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>{t.resultComponentName}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Checkbox
                        checked={t.isInformational}
                        onChange={(event, checked) =>
                          formik.setFieldValue(
                            `trackedComponents.${index}.isInformational`,
                            checked
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button type="button" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
